// extracted by mini-css-extract-plugin
export default {"cancelTicket":"backgroundWrapper_cancelTicket__RWKOz","backgroundWrapper":"backgroundWrapper_backgroundWrapper__o39ed"};